import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import SaleItem from "../../../../../../utilities/data/model/SaleItem";
import { Spacings, View } from "react-native-ui-lib";
import { Text, ProductThumbnail } from "@towersystems/roam-common-native";
import { toTitleCase } from "@towersystems/roam-common/lib/shared-utils";
import { moneyToFormattedString } from "../../../../../../utilities/money";

const getObservables = ({ item }: { item: SaleItem }) => ({
  product: item.product.observe(),
});

export interface ItemRendererProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  item: SaleItem;
}

const ItemRenderer = ({ item, product }: ItemRendererProps) => {
  return (
    <View>
      <View
        flex
        row
        style={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <View
          style={{ alignItems: "center", flexBasis: "100%", flexShrink: 1 }}
          row
        >
          <ProductThumbnail
            imageUrl={product?.imageUrl}
            quantity={item.quantity}
            isInternalProduct={product?.internal}
          />
          <View marginL-20 style={{ flexShrink: 1 }}>
            <Text variant="heading1" numberOfLines={1} ellipsizeMode="head">
              {toTitleCase(item.name ?? (product?.name || ""))}
            </Text>
            <Text>{product?.displayName}</Text>
            <Text color="subdued">
              Stock Number: {item.stockNumber || product?.stockNumber || ""}
            </Text>
            {item.serialNumber ? (
              <Text color="subdued">S/N: {item.serialNumber}</Text>
            ) : null}
            {item.metadata?.surcharge === true ? (
              <Text color="subdued">{item.metadata?.surchargeDescription}</Text>
            ) : null}
            {item.customerNote ? (
              <View>
                <Text numberOfLines={4} color="subdued">
                  {`"${item.customerNote}"`}
                </Text>
              </View>
            ) : null}
          </View>
        </View>
        <View style={{ alignItems: "flex-end" }}>
          <Text variant="heading1">
            {moneyToFormattedString(item.totalPrice)}
          </Text>
          {item.adjustments.length >= 1 ? (
            <Text
              color="subdued"
              variant="heading1"
              style={{
                textDecorationLine: "line-through",
              }}
            >
              {moneyToFormattedString(item.totalBasePrice)}
            </Text>
          ) : undefined}
        </View>
      </View>
    </View>
  );
};

const enhance = withObservables(["item"], getObservables);

export const Item = enhance(ItemRenderer);
